<template lang="pug">
  .auth.auth--web(:class="{'dknusa': DKNUSA}")
    .auth__header(v-if="DKNUSA")
      .auth__header__wrapper
        img.auth__header__logo(:alt="appName" src="@/assets/daikin_color_logo.svg")

    router-view

    .auth__footer(v-if="!DKNUSA")
      | &copy; {{ appName }} 2019. All Rights Reserved.
      br
      | v.{{ version }}

    .auth__footer--dknusa.margin-double-top(v-if="DKNUSA")
      .auth__footer__wrapper
        div
          img.auth__footer__logo(src="@/assets/dknWhite.png")

          .auth__footer__rights © 2019 Daikin North America LLC, All rights reserved.

        .auth__footer__menu
          a.link(:href="certPrivacy" target="_blank") {{ $t('terms.privacy') }}
          a.link(:href="certTerms" target="_blank") {{ $t('terms.terms') }}
          a.link(:href="certLicense" target="_blank") {{ $t('terms.license') }}

</template>

<script>
import i18n from "@/i18n";
import Vue from "vue";
import { PROYECT } from "@/constant";
import { version } from "../package.json";

export default Vue.extend({
  data() {
    return {
      type: PROYECT.TYPE,
      appName: PROYECT.NAME,
      certPrivacy: null,
      certLicense: null,
      certTerms: null,
      appleStorePath: PROYECT.STORE.APPLE,
      androidStorePath: PROYECT.STORE.ANDROID
    };
  },
  computed: {
    version() {
      return version;
    },
    DKNUSA() {
      return this.type === "DKNUSA";
    }
  },
  methods: {
    getCertPrivacy(language) {
      return PROYECT.APP.PRIVACY[language] || PROYECT.APP.PRIVACY.EN;
    },

    getCertLicense(language) {
      return PROYECT.APP.LEGAL[language] || PROYECT.APP.LEGAL.EN;
    },

    getCertTerms(language) {
      return PROYECT.APP.TERMS[language] || PROYECT.APP.TERMS.EN;
    }
  },
  created() {
    const favicon = document.getElementById("favicon");
    favicon.href = `/${PROYECT.LOGO}.ico`;
    document.title = PROYECT.NAME;

    const language = i18n.locale.toUpperCase();
    this.certPrivacy = this.getCertPrivacy(language);
    this.certTerms = this.getCertTerms(language);
    this.certLicense = this.getCertLicense(language);
  }
});
</script>
